import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./pages/Header";
import Footer from "./pages/Footer";
import MainContent from "./pages/MenuBody";
import AdminPanel from "./pages/AdminPanel";
import Login from "./pages/Login";

function AppWrapper() {
  const [restaurantInfo, setRestaurantInfo] = useState(null);
  const [menuData, setMenuData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    // Check localStorage for existing auth token on initial load
    return localStorage.getItem('admin_authenticated') === 'true';
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Add timestamp to prevent caching
        const timestamp = new Date().getTime();
        const apiUrl = process.env.REACT_APP_API_BASE_URL 
          ? `${process.env.REACT_APP_API_BASE_URL}/menu.php?t=${timestamp}`
          : `/menu.php?t=${timestamp}`;
        
        console.log("Fetching from:", apiUrl);
        const response = await fetch(apiUrl);
        const data = await response.json();
        
        console.log("API Response:", data);
        
        if (data.success) {
          console.log("Menu Data:", data.data.menuData);
          setRestaurantInfo(data.data.restaurantInfo);
          setMenuData(data.data.menuData);
        } else {
          throw new Error(data.message || 'Failed to fetch data');
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Save auth state to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('admin_authenticated', isAuthenticated);
  }, [isAuthenticated]);

  if (loading) return <Box sx={{ p: 3 }}>Loading...</Box>;
  if (error) return <Box sx={{ p: 3, color: 'error.main' }}>Error: {error}</Box>;
  if (!restaurantInfo) return <Box sx={{ p: 3 }}>No data available</Box>;

  return (
    <Router>
      <Box sx={{ 
        display: "flex", 
        flexDirection: "column", 
        minHeight: "100vh",
        backgroundColor: "#f9f9f9"
      }}>
        <Header restaurantInfo={restaurantInfo} />
        <Routes>
          <Route path="/" element={
            <MainContent 
              menuData={menuData} 
              qrMenuURL={restaurantInfo.qr_menu_url} 
            />
          } />
          <Route path="/admin" element={
            isAuthenticated ? (
              <AdminPanel 
                menuData={menuData}
                restaurantInfo={restaurantInfo}
              />
            ) : (
              <Login setIsAuthenticated={setIsAuthenticated} />
            )
          } />
          {/* Add a catch-all route for debugging */}
          <Route path="*" element={<Box sx={{ p: 3 }}>404 - Page not found. Path: {window.location.pathname}</Box>} />
        </Routes>
        <Footer restaurantInfo={restaurantInfo} />
      </Box>
    </Router>
  );
}

export default AppWrapper;